var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{attrs:{"required":"","rows":"1","data-min-rows":"3","placeholder":"Type text"},on:{"input":_vm.storeValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }